import { MapPin, CalendarDays, Building2, Clock } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const FIELDS = [
  { icon: MapPin, label: "City" },
  { icon: CalendarDays, label: "Dates" },
  { icon: Building2, label: "Venue" },
  { icon: Clock, label: "Appointment Timings" },
];

export default function Availability({ onRequest }) {
  return (
    <section id="availability" data-testid="availability-section" className="bg-[#1B3B2B] border-t border-[#C5A059]/20 py-16 lg:py-28 relative overflow-hidden">
      <div className="pointer-events-none absolute -top-32 -right-32 w-[420px] h-[420px] rounded-full bg-[#C5A059]/8 blur-3xl" />
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative">
        <Reveal>
          <Eyebrow light>
            <span className="mx-auto">Chapter 10 · USA Visit</span>
          </Eyebrow>
          <h2 className="mt-5 font-serif text-3xl sm:text-4xl lg:text-5xl text-[#FAF7F2] tracking-tight">
            Dr. Santhisree's USA Visit
          </h2>
          <p className="mt-5 text-base text-[#FAF7F2]/75 max-w-xl mx-auto leading-relaxed">
            In-person consultation appointments are available for a limited period during the USA visit.
          </p>
          <div className="mt-6 inline-flex items-center gap-2 bg-[#FAF7F2]/8 border border-[#C5A059]/40 text-[#C5A059] px-5 py-2.5 rounded-full text-xs font-semibold tracking-[0.2em] uppercase">
            <MapPin className="w-4 h-4" />
            USA In-Person Consultations
          </div>
          <p className="mt-6 text-sm text-[#FAF7F2]/60 max-w-lg mx-auto">
            Appointments are scheduled in advance. Submit your details to check availability and consultation pathways.
          </p>
        </Reveal>

        <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-4 max-w-3xl mx-auto">
          {FIELDS.map((f, i) => (
            <Reveal key={f.label} delay={i * 0.08}>
              <div className="bg-[#FAF7F2]/6 border border-[#FAF7F2]/12 rounded-2xl p-5">
                <f.icon className="w-5 h-5 text-[#C5A059] mx-auto" />
                <p className="mt-3 text-[10px] tracking-[0.24em] uppercase text-[#FAF7F2]/50">{f.label}</p>
                <p className="mt-1 text-sm text-[#FAF7F2]/85 font-medium">To be announced</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <button
            data-testid="availability-cta"
            onClick={() => onRequest()}
            className="mt-10 bg-[#C5A059] text-[#1B3B2B] font-semibold tracking-wide text-sm px-9 py-4 rounded-full hover:bg-[#D4AF37] transition-all duration-300 hover:-translate-y-0.5 shadow-[0_16px_40px_rgb(197,160,89,0.3)]"
          >
            CHECK APPOINTMENT AVAILABILITY
          </button>
        </Reveal>
      </div>
    </section>
  );
}
